const offerExternalIntegrations = require('../../../enums/offer-external-integrations');
const {
	idProviders,
	SMARTCREDIT,
	PIXEL,
	SCRIPT,
	ONLINE_PAYMENTS,
	referenceNames
} = offerExternalIntegrations;
const externalIntegrations = offerExternalIntegrations.enum;

const ENCODE_BASE = 25;
const sidsEnum = ['sid1', 'sid2', 'sid3', 'sid4', 'sid5'];

const base64encode = string => {
	switch (true) {
		case typeof window !== 'undefined':
			return window.btoa(string);
		case Boolean(Buffer):
			return Buffer.from(string).toString('base64');
		default:
			return string;
	}
};

const encodeNumber = (number = 0) => number.toString(ENCODE_BASE);

const decodeNumber = (string = '') => parseInt(string, ENCODE_BASE);

function getPartnerLandingUrl({
	campaignId,
	externalIntegration,
	sids = {},
	useRedirect = false,
	offerDomain,
	redirectDomain,
	toBasket = false,
	landings_snippets_codes = null,
	landingSnippets = null
}) {
	const encodedCampaignId = encodeNumber(parseInt(campaignId));
	let baseUrl = '';
	let queryPairs = [];

	let sidsArray = [];
	sidsEnum.forEach(sidKey => {
		if (sids[sidKey]) {
			sidsArray.push(`${sidKey}=${sids[sidKey]}`);
		}
	});
	const hasSids = sidsArray.length > 0;
	const sidsString = sidsArray.join('&');

	function getRedirectBaseUrl() {
		return `https://${redirectDomain}`;
	}
	if (landings_snippets_codes && landingSnippets) {
		const iframeSnippet = landingSnippets.find(i => i.name.toLowerCase() === 'iframe');
		const snippetCode = iframeSnippet &&
			landings_snippets_codes.landing.find(i => i.id === iframeSnippet.external_id);
		sidsEnum.forEach(sd => {
			snippetCode &&
			snippetCode.text.includes(sd) &&
			queryPairs.push(`${sd}=${sd.toUpperCase()}`);
		});
	}

	function returnUrl() {
		const queryString = queryPairs.join('&');
		const delimiter = queryString.length ? (baseUrl.includes('?') ? '&' : '?') : '';
		return {
			fullUrl: `${baseUrl}${delimiter}${queryString}`,
			baseUrl,
			queryString,
			delimiter
		};
	}

	if (idProviders[externalIntegration] === SMARTCREDIT) {
		const reference = referenceNames[externalIntegration];

		if (useRedirect) {
			baseUrl = getRedirectBaseUrl();
			hasSids && queryPairs.push(sidsString);
		} else {
			baseUrl = `https://smartcredit.ru/?affiliate=${reference}&referrer=${encodedCampaignId}`;
			hasSids && queryPairs.push(`channel=${base64encode(sidsString)}`);
		}
		return returnUrl();
	}
	if (externalIntegration === externalIntegrations[PIXEL]) {
		hasSids && queryPairs.push(sidsString);
		if (useRedirect) {
			baseUrl = getRedirectBaseUrl();
		} else {
			baseUrl = `https://${offerDomain}?utm_source=aff&utm_medium=everad&id_cam=${encodedCampaignId}`;
		}
		return returnUrl();
	}
	if (externalIntegration === externalIntegrations[SCRIPT]) {
		hasSids && queryPairs.push(sidsString);
		if (useRedirect) {
			baseUrl = getRedirectBaseUrl();
		} else {
			baseUrl = `https://${offerDomain}?id_cam=${encodedCampaignId}`;
		}
		return returnUrl();
	}
	if (externalIntegration === externalIntegrations[ONLINE_PAYMENTS]) {
		baseUrl = `https://${offerDomain}${toBasket ? '/shipping-information' : ''}?id_cam=${encodedCampaignId}`;
		return returnUrl();
	}
	throw new Error(`external_integration "${externalIntegration}" is not supported`);
}

module.exports = {
	getPartnerLandingUrl,
	encodeNumber,
	decodeNumber
};



// WEBPACK FOOTER //
// ./frontend/shared/js/externalOfferHelpers.js